import { render } from "./LanguageSwitch.vue?vue&type=template&id=296c44eb&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=296c44eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-296c44eb"

export default script